import React, { useState } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  Typography,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

const StyledButton = styled(Button)({
  margin: "8px 4px 2px 4px",
  padding: "0 1px",
  height: "16px",
  lineHeight: "16px",
  width: "calc(50% - 6px)",
  textAlign: "center",
  fontSize: "12px",
  color: "rgba(0, 0, 0, 0.8)",
  border: "1px solid transparent",
  borderRadius: "1px",
  backgroundColor: "rgba(0, 0, 0, 0.18)",
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    boxShadow: "none",
  },
});
const selectStyles = {
  width: 88,
  height: 22,
  borderRadius: "1px",
  borderWidth: "1px",
  gap: "4px",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  textTransform: "uppercase",
  padding: "0",
  "& .MuiSelect-select": {
    width: "100%",
    textTransform: "uppercase",
    textOverflow: "clip",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  "& .MuiSelect-icon": {
    marginLeft: "20px",
    right: "5px",
  },
};

const MonthSelectorDropdown = ({
  months,
  selectedMonths,
  onApply,
  label = "Month",
}) => {
  const [open, setOpen] = useState(false);
  const [tempSelectedMonths, setTempSelectedMonths] = useState(selectedMonths);
  const maxTextLength = 6;
  const handleMonthSelectChange = (event) => {
    const { value } = event.target;

    if (value.includes("All")) {
      setTempSelectedMonths(
        tempSelectedMonths.length === months.length ? [] : months
      );
    } else {
      setTempSelectedMonths(value);
    }
  };

  const handleApply = () => {
    onApply(tempSelectedMonths);
    setOpen(false);
  };

  const handleCancel = () => {
    setTempSelectedMonths(selectedMonths);
    setOpen(false);
  };

  const handleClose = () => {
    setTempSelectedMonths(selectedMonths);
    setOpen(false);
  };

  return (
    <FormControl className="month-selector">
      <Typography id="month-select-label" className="month-selector-label">
        {label}
      </Typography>
      <Select
        labelId="month-select-label"
        multiple
        value={tempSelectedMonths}
        onChange={handleMonthSelectChange}
        size="small"
        open={open}
        onOpen={() => setOpen(true)}
        onClose={handleClose}
        sx={selectStyles}
        displayEmpty
        renderValue={(selected) => {
          const text = Array.isArray(selected) ? selected.join(", ") : selected;
          return text.length > maxTextLength
            ? `${text.substring(0, maxTextLength)}...`
            : text;
        }}
      >
        <MenuItem value="All">
          <Checkbox
            checked={tempSelectedMonths.length === months.length}
            sx={{
              transform: "scale(0.8)",
              padding: "0 !important",
              "& .MuiSvgIcon-root": { fontSize: "19px" },
            }}
          />
          All
        </MenuItem>
        {months.map((month) => (
          <MenuItem key={month} value={month}>
            <Checkbox
              checked={tempSelectedMonths.includes(month)}
              sx={{
                transform: "scale(0.8)",
                padding: "0 !important",
                "& .MuiSvgIcon-root": { fontSize: "19px" },
              }}
            />
            {month}
          </MenuItem>
        ))}
        <Box display="flex" justifyContent="space-between" p={0}>
          <StyledButton
            onClick={handleApply}
            variant="contained"
            color="primary"
            disabled={tempSelectedMonths.length === 0}
          >
            Apply
          </StyledButton>
          <StyledButton
            onClick={handleCancel}
            variant="outlined"
            color="secondary"
          >
            Cancel
          </StyledButton>
        </Box>
      </Select>
    </FormControl>
  );
};

export default MonthSelectorDropdown;
